export const operatorKeys = {
  IN: 'in',
  NOT_IN: 'not in',
  CONTAINS: 'contains',
  DOES_NOT_CONTAIN: 'does not contain',
  EQUAL_TO: 'equal to',
  NOT_EQUAL_TO: 'not equal to',
  GREATER_THAN: 'greater than',
  GREATER_THAN_OR_EQUAL_TO: 'greater than or equal to',
  LESS_THAN: 'less than',
  LESS_THAN_OR_EQAUL_TO: 'less than or equal to',
  STARTS_WITH: 'starts with',
  DOES_NOT_START_WITH: 'does not start with',
  ENDS_WITH: 'ends with',
  DOES_NOT_ENDS_WITH: 'does not ends with'
};

export const operatorLabels = {
  [operatorKeys.CONTAINS]: 'Contains',
  [operatorKeys.DOES_NOT_CONTAIN]: 'Does Not Contain',
  [operatorKeys.EQUAL_TO]: 'Equals To',
  [operatorKeys.NOT_EQUAL_TO]: 'Not Equals To',
  [operatorKeys.GREATER_THAN]: 'Greater Than',
  [operatorKeys.GREATER_THAN_OR_EQUAL_TO]: 'Greater Than Or Equal To',
  [operatorKeys.LESS_THAN]: 'Less Than',
  [operatorKeys.LESS_THAN_OR_EQAUL_TO]: 'Less Than Or Equal To',
  [operatorKeys.STARTS_WITH]: 'Starts With',
  [operatorKeys.DOES_NOT_START_WITH]: 'Does Not Starts With',
  [operatorKeys.ENDS_WITH]: 'Ends With',
  [operatorKeys.DOES_NOT_ENDS_WITH]: 'Does Not Ends With',
  [operatorKeys.IN]: 'In',
  [operatorKeys.NOT_IN]: 'Not In'
};

export const operatorsArray = [
  {
    value: operatorKeys.IN,
    label: operatorLabels[operatorKeys.IN]
  },
  {
    value: operatorKeys.NOT_IN,
    label: operatorLabels[operatorKeys.NOT_IN]
  },
  {
    value: operatorKeys.CONTAINS,
    label: operatorLabels[operatorKeys.CONTAINS]
  },
  {
    value: operatorKeys.DOES_NOT_CONTAIN,
    label: operatorLabels[operatorKeys.DOES_NOT_CONTAIN]
  },
  {
    value: operatorKeys.EQUAL_TO,
    label: operatorLabels[operatorKeys.EQUAL_TO]
  },
  {
    value: operatorKeys.NOT_EQUAL_TO,
    label: operatorLabels[operatorKeys.NOT_EQUAL_TO]
  },
  {
    value: operatorKeys.GREATER_THAN,
    label: operatorLabels[operatorKeys.GREATER_THAN]
  },
  {
    value: operatorKeys.GREATER_THAN_OR_EQUAL_TO,
    label: operatorLabels[operatorKeys.GREATER_THAN_OR_EQUAL_TO]
  },
  {
    value: operatorKeys.LESS_THAN,
    label: operatorLabels[operatorKeys.LESS_THAN]
  },
  {
    value: operatorKeys.LESS_THAN_OR_EQAUL_TO,
    label: operatorLabels[operatorKeys.LESS_THAN_OR_EQAUL_TO]
  },
  {
    value: operatorKeys.STARTS_WITH,
    label: operatorLabels[operatorKeys.STARTS_WITH]
  },
  {
    value: operatorKeys.DOES_NOT_START_WITH,
    label: operatorLabels[operatorKeys.DOES_NOT_START_WITH]
  },
  {
    value: operatorKeys.ENDS_WITH,
    label: operatorLabels[operatorKeys.ENDS_WITH]
  },
  {
    value: operatorKeys.DOES_NOT_ENDS_WITH,
    label: operatorLabels[operatorKeys.DOES_NOT_ENDS_WITH]
  }
];

export const arithmeticOperatorKeys = {
  decrement: 'subtract',
  increment: 'add',
  multiply: 'multiply',
  divide: 'divide'
};

export const arithmeticKeysFromLabel = {
  '- (Subtraction)': arithmeticOperatorKeys.decrement,
  '+ (Addition)': arithmeticOperatorKeys.increment,
  '÷ (Division)': arithmeticOperatorKeys.divide,
  'X (Multiplication)': arithmeticOperatorKeys.multiply
};

export const arithmeticMathKeysFromLabel = {
  '- (Subtraction)': '-',
  '+ (Addition)': '+',
  '÷ (Division)': '÷',
  'X (Multiplication)': 'x'
};

export const arithmeticOperatorLabels = {
  [arithmeticOperatorKeys.decrement]: '- (Subtraction)',
  [arithmeticOperatorKeys.increment]: '+ (Addition)',
  [arithmeticOperatorKeys.divide]: '÷ (Division)',
  [arithmeticOperatorKeys.multiply]: 'X (Multiplication)'
};

export const arithmeticOperatorsArray = [
  {
    value: arithmeticOperatorKeys.increment,
    label: arithmeticOperatorLabels[arithmeticOperatorKeys.increment]
  },
  {
    value: arithmeticOperatorKeys.decrement,
    label: arithmeticOperatorLabels[arithmeticOperatorKeys.decrement]
  },
  {
    value: arithmeticOperatorKeys.divide,
    label: arithmeticOperatorLabels[arithmeticOperatorKeys.divide]
  },
  {
    value: arithmeticOperatorKeys.multiply,
    label: arithmeticOperatorLabels[arithmeticOperatorKeys.multiply]
  }
];

export const listOperators = [operatorKeys.IN, operatorKeys.NOT_IN];
